import { useCallback, useState } from "react";
import { useApi } from "../apiCall/useApi";
import Joi from "joi";
import { Urls } from "../../../utils/constant";
import { size } from "lodash";
import { useSnackbar } from "notistack";

import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import { useDispatch, useSelector } from "react-redux";

import Api from "../../../utils/api.utils";
import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";
import {
  setAreaData,
  setConsultData,
  setDoctorData,
} from "../../reducers/Doctor/doctorForm.reducer";
import {
  getAreaList,
  getConsultList,
} from "../../selectors/Doctor/doctorform.selector";

export const doctorEntrySchema = Joi.object({
  name: Joi.string().trim().required().messages({
    "string.empty": "Doctor Name is required.",
  }),

  speciality: Joi.string().required().messages({
    "string.empty": "Speciality is required.",
  }),

  experience: Joi.number()
    .integer()
    .required()
    .custom((value, helpers) => {
      if (value.toString().length > 2) {
        return helpers.message("Experience must be exactly 2 digits.");
      }
      return value;
    })
    .messages({
      "number.base": "Experience is required.",
    }),

  biography: Joi.string().optional().allow(""),

  location_url: Joi.string().required().messages({
    "string.empty": "Location is required.",
  }),

  working_time: Joi.string().min(4).required().messages({
    "string.empty": "Working Time is required.",
    "string.min": "Please enter a valid working time.",
  }),

  slot_timing: Joi.string().required().messages({
    "string.empty": "Slot Timing is required.",
  }),

  area_name: Joi.array().min(1).required().messages({
    "array.min": "Please select at least one area.",
    "array.base": "Area Name selection is required.",
  }),

  consult_name: Joi.array().min(1).required().messages({
    "array.min": "Please select at least one Consult.",
    "array.base": "Consult Name selection is required.",
  }),
});

export function useDoctorForm({
  existingStatus,
  existingImageUrl,
  existingAreaId,
  existingConsultId,
}) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [status, setStatus] = useState(existingStatus === 2 ? 0 : 1);
  const [Image, setImage] = useState(existingImageUrl);
  const areaList = useSelector(getAreaList);
  const consultList = useSelector(getConsultList);
  const [areaId, setAreaId] = useState(existingAreaId);
  const [consultId, setConsultId] = useState(existingConsultId);
  const [Id, setId] = useState("");
  const [Name, setName] = useState("");
  const [Speciality, setSpeciality] = useState("");
  const [Biography, setBiography] = useState("");
  const [Experience, setExperience] = useState("");
  const [LocationUrl, setLocationUrl] = useState("");
  const [SlotTiming, setSlotTiming] = useState("");
  const [WorkTiming, setWorkTiming] = useState("");
  //   const [ReportDate, setReportDate] = useState(existingReportDate);
  const handleFileChange = useCallback((img) => {
    setImage(img);
  }, []);

  const handleDeleteId = useCallback(
    (row) => {
      setImage(row.image_url);
      setId(row.id);
      setName(row.name);
      setSpeciality(row.speciality);
      setBiography(row.biography);
      setExperience(row.experience);
      setLocationUrl(row.location_url);
      setSlotTiming(row.slot_timing);
      setWorkTiming(row.working_time);
    },
    [
      Id,
      Name,
      Image,
      Speciality,
      Biography,
      Experience,
      LocationUrl,
      SlotTiming,
      WorkTiming,
    ]
  );
  const doctorEntry = useCallback(
    async ({
      name,
      speciality,
      experience,
      biography,
      location_url,
      working_time,
      slot_timing,
    }) => {
      const status_Val = status === false ? 2 : status === 0 ? 2 : 1;
      const form = new FormData();
      form.append("file", Image);
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());
        // const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');
        const image_response = await Api.post2(
          {
            url: Urls.imageAdd(),
            data: form,
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          },
          []
        );

        let image_url = image_response?.data[0]?.url;
        const { data } = await apiPost({
          url: Urls.doctorAdd(),
          data: {
            name: name,
            image_url: image_url,
            speciality: speciality,
            experience: experience,
            biography: biography,
            location_url: location_url,
            working_time: working_time,
            slot_timing: slot_timing,
            area_id: areaId,
            consult_id: consultId,
            status: status_Val,
            insert_by: "",
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (size(data?.id) === 36) {
          enqueueSnackbar("Doctor Data Added Successfully.", {
            variant: "success",
          });
          return true;
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading, Image, areaId, consultId]
  );
  // while update when i click on the save button without changing any data then the area id and consult _ id is getting null

  const doctorUpdate = useCallback(
    async ({
      id,
      name,
      speciality,
      experience,
      biography,
      location_url,
      slot_timing,
      working_time,
    }) => {
      if (loading) return;
      setLoading(true);
      const status_Val = status === false ? 2 : status === 0 ? 2 : 1;
      let image_url = [];
      try {
        dispatch(showPageLoader());

        if (size(Image?.name) > 0) {
          const form = new FormData();
          form.append("file", Image);
          const image_response = await Api.post2(
            {
              url: Urls.imageAdd(),
              data: form,
              headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
              },
            },
            []
          );
          image_url.push(image_response?.data[0]?.url);
        }

        const { data } = await apiPost({
          url: Urls.doctorUpdate(),
          data: {
            id: id,
            name: name,
            image_url: image_url.length > 0 ? image_url[0] : Image?.url,
            speciality: speciality,
            experience: experience,
            biography: biography,
            slot_timing: slot_timing,
            location_url: location_url,
            working_time: working_time,
            area_id: areaId,
            consult_id: consultId,
            status: status_Val,
            update_by: "",
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (size(data?.id) === 36) {
          enqueueSnackbar("Doctor Data Updated Successfully.", {
            variant: "success",
          });
          return true;
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading, Image, areaId, consultId]
  );

  const doctorDelete = useCallback(async () => {
    //   const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');

    try {
      dispatch(showPageLoader());
      const { data } = await apiPost({
        url: Urls.doctorUpdate(),
        data: {
          id: Id,
          name: Name,
          image_url: Image,
          speciality: Speciality,
          experience: Experience,
          biography: Biography,
          slot_timing: SlotTiming,
          location_url: LocationUrl,
          working_time: WorkTiming,
          area_id: existingAreaId,
          consult_id: existingConsultId,
          status: 2,
          update_by: "",
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (size(data?.id) === 36) {
        enqueueSnackbar("Doctor Data Deleted Successfully.", {
          variant: "success",
        });
        return true;
      }

      setLoading(false);
      dispatch(hidePageLoader());
    } catch (err) {
      dispatch(hidePageLoader());
      console.log(err);
      setLoading(false);
      return false;
    }
  }, [
    status,
    Id,
    Name,
    Image,
    LocationUrl,
    Speciality,
    Experience,
    SlotTiming,
    Biography,
    LocationUrl,
    WorkTiming,
  ]);

  const getDoctorbyId = useCallback(
    async (id) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());
        const { data } = await apiPost({
          url: Urls.getDoctorDatabyId(),
          data: {
            id: id,
          },
        });

        dispatch(setDoctorData(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading]
  );

  const fetchAreaComboList = useCallback(async () => {
    try {
      const { data } = await apiPost({
        url: Urls.getAreaCombo(),
        data: {},
      });
      // setting list to reducer
      dispatch(setAreaData(data));
    } catch (err) {
      console.log(err);
    }
  }, [areaId]);

  const findAreaFromLabel = useCallback(
    (values) => {
      const areaIds = values.map(
        (value) => areaList.find((item) => item.label === value)?.id
      );
      setAreaId(areaIds.filter((id) => id !== undefined));
    },
    [areaList]
  );

  const fetchConsultComboList = useCallback(async () => {
    try {
      const { data } = await apiPost({
        url: Urls.getConsultCombo(),
        data: {},
      });
      // setting list to reducer
      dispatch(setConsultData(data));
    } catch (err) {
      console.log(err);
    }
  }, [consultId]);

  const findConsultFromLabel = useCallback(
    (values) => {
      const consultIds = values.map(
        (value) => consultList.find((item) => item.label === value)?.id
      );
      setConsultId(consultIds.filter((id) => id !== undefined));
    },
    [consultList]
  );

  const handleStatusComboChange = useCallback((event) => {
    if (event.target.checked === 1) {
      setStatus(event.target.checked);
    } else {
      setStatus(event.target.checked);
    }
  }, []);

  return {
    loader,
    loading,
    status,
    areaId,
    consultId,
    doctorEntrySchema,
    handleStatusComboChange,
    doctorEntry,
    doctorUpdate,
    handleFileChange,
    getDoctorbyId,
    fetchAreaComboList,
    findAreaFromLabel,
    fetchConsultComboList,
    findConsultFromLabel,
    handleDeleteId,
    doctorDelete,
  };
}
